'use client';

import type { ImageLoaderProps } from 'next/image';

import { isRasterImage, toEdgeAssetUrl } from './utils';

export default function sanityImageLoader({
  src,
  width,
  quality,
}: ImageLoaderProps): string {
  // Try to parse as absolute URL
  let u: URL;
  try {
    u = new URL(src);
  } catch {
    // Relative/local path — return as-is (already a static asset)
    return src;
  }

  // Sanity images, from the CDN or our /n_sanity/ proxy — request exact size
  const isSanityImage =
    (u.hostname.endsWith('sanity.io') || u.pathname.startsWith('/n_sanity/')) &&
    u.pathname.includes('/images/');

  if (isSanityImage) {
    // Explicit format, never auto=format (see urlForImage). SVG/GIF keep theirs.
    u.searchParams.delete('auto');
    if (isRasterImage(u.pathname)) {
      u.searchParams.set('fm', 'webp');
    } else {
      u.searchParams.delete('fm');
    }
    u.searchParams.set('fit', u.searchParams.get('fit') ?? 'max');
    u.searchParams.set('w', String(width));
    u.searchParams.set('q', String(quality ?? 75));
    return toEdgeAssetUrl(u.toString()) as string;
  }

  // Other external images — return as-is
  return src;
}
